import React, { type FC } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import {
	SpecificAccessDetails,
	type SpecificAccessDetailsProps,
} from './specificAccessDetails/SpecificAccessDetails';
import {
	PublicLinkDialogBody,
	type PublicLinkDialogBodyProps,
} from './publicLink/PublicLinkDialogBody';
import {
	ShareToSlackDialogBody,
	type ShareToSlackDialogBodyProps,
} from './shareToSlack/ShareToSlackDialogBody';
import {
	AccessRequestsDialogBody,
	type AccessRequestsDialogBodyProps,
} from './accessRequests/AccessRequestsDialogBody';

export type BodyProps = {
	specificAccessDetails?: SpecificAccessDetailsProps;
	publicLinkDialogBody?: PublicLinkDialogBodyProps;
	shareToSlackDialogBody?: ShareToSlackDialogBodyProps;
	accessRequestsDialogBody?: AccessRequestsDialogBodyProps;
	// Alternative modes' bodies to go here, if we end up supporting any
};

export const Body: FC<BodyProps> = ({
	specificAccessDetails,
	publicLinkDialogBody,
	shareToSlackDialogBody,
	accessRequestsDialogBody,
}: BodyProps) => {
	return (
		<Stack grow="fill">
			{specificAccessDetails && <SpecificAccessDetails {...specificAccessDetails} />}
			{publicLinkDialogBody && <PublicLinkDialogBody {...publicLinkDialogBody} />}
			{shareToSlackDialogBody && <ShareToSlackDialogBody {...shareToSlackDialogBody} />}
			{accessRequestsDialogBody && <AccessRequestsDialogBody {...accessRequestsDialogBody} />}
			{/* TODO: different bodies, if we do end up supporting different modes */}
		</Stack>
	);
};
